import {buildTimePoint} from '../../componentOutliers/buildPoints';
import {HistoryRecord} from '../../componentOutliers/types';
import {
  BucketedQueryRuns,
  BucketedQueryRunsDelta,
  GroupedBucketedQueryRunWithGroupedRunConnection,
} from './types';

export function postProcessRuns(runs: BucketedQueryRuns | null | undefined) {
  // post process data - we need to calculate absolute runtime if it might be used
  // _absolute_runtime is a derived metric that is calculated off the run's start time
  try {
    runs?.deltas?.delta?.forEach((runDelta: BucketedQueryRunsDelta) => {
      const createdAt = runDelta?.run?.createdAt ?? '';
      const startTimeInMs = new Date(createdAt).getTime();
      runDelta?.run?.bucketedHistory?.forEach((bucket: HistoryRecord[]) => {
        if (bucket.length > 0) {
          const firstPoint = bucket[0];

          if (
            '_runtimeLast' in firstPoint &&
            '_timestampLast' in firstPoint &&
            '_stepLast' in firstPoint
          ) {
            // this represents a bucket that we might need _absolute_runtime for, so we need to calculate it
            // when the data comes into the Full Fidelity Context
            bucket.forEach((point: HistoryRecord) => {
              buildTimePoint(point, {
                value: startTimeInMs,
                unit: 'milliseconds',
              });
            });
          }
        }
      });
    });
  } catch (e) {
    console.error(
      'Error creating _absolute_runtime metrics in bucketed query manager',
      e
    );
  }
}

export function postProcessGroupedRuns(
  runs: GroupedBucketedQueryRunWithGroupedRunConnection | null | undefined
) {
  try {
    runs?.deltas?.delta?.forEach(runDelta => {
      const createdAt = runDelta?.groupedRun?.createdAt ?? '';
      const startTimeInMs = new Date(createdAt).getTime();
      runDelta?.groupedRun?.bucketedHistory?.forEach(
        (bucket: HistoryRecord[]) => {
          if (bucket.length > 0) {
            const firstPoint = bucket[0];

            if (
              '_runtimeLast' in firstPoint &&
              '_timestampLast' in firstPoint &&
              '_stepLast' in firstPoint
            ) {
              // this represents a bucket that we might need _absolute_runtime for, so we need to calculate it
              // when the data comes into the Full Fidelity Context
              bucket.forEach((point: HistoryRecord) => {
                buildTimePoint(point, {
                  value: startTimeInMs,
                  unit: 'milliseconds',
                });
              });
            }
          }
        }
      );
    });
  } catch (e) {
    console.error(
      'Error creating _absolute_runtime metrics in bucketed query manager',
      e
    );
  }
}
